import { Route, Routes } from 'react-router-dom';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import { useAccountApi } from '@api/services/accountService/accountApiService';

import MainAppBar from '../../components/MainAppBar/MainAppBar';
import MainPage from '../MainPage/MainPage';
import Profile from '../Profile/Profile';
import Details from '../Order/Details';
import PaymentHistory from '../PaymentHistory/PaymentHistory';
import PaymentSchedule from '../PaymentSchedule/PaymentSchedule';
import PaymentSuccess from '../PaymentSuccess/PaymentSuccess';
import PaymentFailed from '../PaymentFailed/PaymentSuccess';
import { NotFound } from '../NotFound/NotFound';
import BannerGetTheApp from '../BannerGetTheApp';
import CreditAccountPage from '../Accounts/CreditAccountPage';
import LoanAccountPage from '../Accounts/LoanAccountPage';
import QrRepaymentPage from '../QrRepayment/QrRepaymentPage';
import { accountMapper } from '@api/mappers/accountMapper';
import { AuthInfo } from '@fhl-world/auth-core/webpack-esm';

const Container = styled.main`
	max-width: 380px;
	margin: auto;
	padding: 16px;
	color: rgba(27, 31, 59, 0.8);
`;

type RoutePageProps = {
	user: AuthInfo['user'];
};

function RoutePage(props: RoutePageProps) {
	const { user } = props;

	const accountsState = useAccountApi();
	const mappedAccountsState = accountMapper(accountsState);
	const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

	return (
		<div>
			<BannerGetTheApp />
			<MainAppBar userName={user.fullName} />
			<Container>
				<SentryRoutes>
					<Route
						path={'/'}
						element={<MainPage accountsState={mappedAccountsState} />}
					/>

					<Route
						path={'/financing/:accountId'}
						element={<LoanAccountPage accountsState={mappedAccountsState} />}
					/>
					<Route
						path={'/creditLine/:accountId'}
						element={<CreditAccountPage accountsState={mappedAccountsState} />}
					/>
					<Route
						path={'/qrRepayment/:accountId'}
						element={
							<QrRepaymentPage
								accountsState={mappedAccountsState}
								userName={user.fullName}
							/>
						}
					/>

					<Route path={'/profile'} element={<Profile profileData={user} />} />
					<Route
						path={'/order/:loanId'}
						element={<Details accountsState={mappedAccountsState} />}
					/>
					<Route
						path={'/history/:accountId'}
						element={<PaymentHistory accountsState={mappedAccountsState} />}
					/>
					<Route
						path={'/schedule/:loanId'}
						element={<PaymentSchedule accountsState={mappedAccountsState} />}
					/>
					<Route path={'/payment_success'} element={<PaymentSuccess />} />
					<Route path={'/payment_error'} element={<PaymentFailed />} />
					<Route path="*" element={<NotFound />} />
				</SentryRoutes>
			</Container>
		</div>
	);
}

export default RoutePage;
